import type { AdminActorRef } from '@/hooks/admin/services/types';
import type { NormalizeOrganizationServiceActorFromApiParams } from '../types';
import throwUnsupportedOrganizationService from './throwUnsupportedOrganizationService';

const normalizeOrganizationServiceActorFromApi = ({
    actor,
}: NormalizeOrganizationServiceActorFromApiParams): AdminActorRef => {
    if (typeof actor !== 'object' || actor === null) {
        return throwUnsupportedOrganizationService({});
    }

    const actorRecord = actor as {
        uid?: unknown;
        email?: unknown;
        displayName?: unknown;
        photoURL?: unknown;
    };

    if (
        typeof actorRecord.uid !== 'string' ||
        typeof actorRecord.email !== 'string' ||
        typeof actorRecord.displayName !== 'string' ||
        (actorRecord.photoURL !== null && typeof actorRecord.photoURL !== 'string')
    ) {
        return throwUnsupportedOrganizationService({});
    }

    return {
        uid: actorRecord.uid,
        email: actorRecord.email,
        displayName: actorRecord.displayName,
        photoURL: actorRecord.photoURL,
    };
};

export default normalizeOrganizationServiceActorFromApi;
